import { render, staticRenderFns } from "./AskSearch.vue?vue&type=template&id=263af1ca"
import script from "./AskSearch.vue?vue&type=script&lang=js"
export * from "./AskSearch.vue?vue&type=script&lang=js"
import style0 from "./AskSearch.vue?vue&type=style&index=0&id=263af1ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports